export function renderTrackEvent(ffEnable, customCallback) {
  const primaryCallBack = customCallback ? customCallback : 'hpsmart://acceptAllRendered';
  ffEnable && window.location.assign(primaryCallBack);
}